// #region Imports
import { useEffect, useState, useCallback } from 'react';
import configuracoesApi from '../services/configuracoesApi';
// #endregion

export default function useConfiguracoes() {
  // #region Estado base
  const [config, setConfig] = useState(configuracoesApi.defaultConfig);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);
  const [dirty, setDirty] = useState(false);
  // #endregion

  // #region Efeito: carga inicial
  useEffect(() => {
    let active = true;
    (async () => {
      setLoading(true);
      setError(null);
      try {
        const cfg = await configuracoesApi.getConfiguracoes();
        if (active) setConfig(cfg);
      } catch (e) {
        if (active) setError(e);
      } finally {
        if (active) setLoading(false);
      }
    })();
    return () => { active = false; };
  }, []);
  // #endregion

  // #region Mutação local (patch incremental)
  const patchConfig = useCallback((patch) => {
    setConfig(prev => ({ ...prev, ...patch }));
    setDirty(true);
  }, []);
  // #endregion

  // #region Persistência
  const save = useCallback(async () => {
    setSaving(true);
    setError(null);
    try {
      const saved = await configuracoesApi.saveConfiguracoes(config);
      setConfig(saved);
      setDirty(false);
      return saved;
    } catch (e) {
      setError(e);
      throw e;
    } finally {
      setSaving(false);
    }
  }, [config]);

  const reset = useCallback(async () => {
    const def = await configuracoesApi.resetConfiguracoes();
    setConfig(def);
    setDirty(false);
  }, []);

  const limparDados = useCallback(async () => {
    await configuracoesApi.limparDadosTeste();
  }, []);
  // #endregion

  // #region Export
  return {
    config,
    loading,
    saving,
    dirty,
    error,
    patchConfig,
    save,
    reset,
    limparDados,
  };
  // #endregion
}
